import React, { useState, useEffect } from "react";
import "../styles/App.scss";
import { BASE_URL, DAMAGE_DATA, FALLBACK_COLOR, PROVIDER_COLOR, PROVIDER_ID, WEB_FORM_DATA_ROW } from "../config";
import { HeaderLogo, NavbarAndForm, Footer, Loading } from "../Components";

export const DataContext = React.createContext();

function App() {
  const [providerData, setProviderData] = useState(null);
  const [webFormData, setWebFormData] = useState(null);
  const [formValues, setFormValues] = useState([]);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [activeTab, setActiveTab] = useState("start");
  const [policyForm, setPolicyForm] = useState(null);
  const [damageData, setDamageData] = useState(null);
  const [navArray, setNavArray] = useState(null);
  const [appUserPolicyData, setAppUserPolicyData] = useState(null);
  const [endpointError, setEndpointError] = useState(false);
  const [startDescription, setStartDescription] = useState("");
  const [claimantDescription, setClaimantDescription] = useState("");
  const [privacyPolicy, setPrivacyPolicy] = useState(null);
  const [requiredFields, setRequiredFields] = useState([]);
  const [dvlaClassFields, setDvlaClassFields] = useState([]);

  //console.log("form values", formValues); 

  let urls = [
    `${BASE_URL}/provider/single/${PROVIDER_ID}?webform=true`,
    `${BASE_URL}/built-in-form/${PROVIDER_ID}/${WEB_FORM_DATA_ROW}`,
  ];

  let requests = urls.map((url) =>
    fetch(url).then((response) => response.json())
  );

  const fetchData = () => {
    Promise.all(requests).then((data) => {
      let intEndpointError = false;
      data.forEach((response) =>{
        if(response.status === "error"){
          intEndpointError = true;
        }
      });
      if(!intEndpointError){
        setProviderData(data[0]);
        setWebFormData(data[1]);
        setStartDescription(data[1].data.startDescription);
        setClaimantDescription(data[1].data.claimantDescription);
        if(typeof data[1].data.privacyPolicy !== undefined){
          setPrivacyPolicy(data[1].data.privacyPolicy);
        }
      }
      getDamageMarker();
      setEndpointError(intEndpointError);
    });
  };

  const hexToRGB = h => {
    let r = 0, g = 0, b = 0;
  
    // 3 digits
    if (h.length == 4) {
      r = "0x" + h[1] + h[1];
      g = "0x" + h[2] + h[2];
      b = "0x" + h[3] + h[3];
  
    // 6 digits
    } else if (h.length == 7) {
      r = "0x" + h[1] + h[2];
      g = "0x" + h[3] + h[4];
      b = "0x" + h[5] + h[6];
    }
    
    return + +r + ", " + +g + ", " + +b;
  }

  const ColorLuminance = (hex, lum) => {

    // validate hex string
    hex = String(hex).replace(/[^0-9a-f]/gi, '');
    if (hex.length < 6) {
      hex = hex[0]+hex[0]+hex[1]+hex[1]+hex[2]+hex[2];
    }
    lum = lum || 0;
  
    // convert to decimal and change luminosity
    var rgb = "#", c, i;
    for (i = 0; i < 3; i++) {
      c = parseInt(hex.substr(i*2,2), 16);
      c = Math.round(Math.min(Math.max(0, c + (c * lum)), 255)).toString(16);
      rgb += ("00"+c).substr(c.length);
    }
  
    return rgb;
  }

  const root = document.documentElement;    
  const hoverColor = ColorLuminance(PROVIDER_COLOR, 0.15);
  root?.style.setProperty("--provider-style", PROVIDER_COLOR);
  root?.style.setProperty("--provider-hover-style", hoverColor);
  root?.style.setProperty("--provider-shadow-style",PROVIDER_COLOR+"80");
  root?.style.setProperty("--bs-primary", PROVIDER_COLOR);
  root?.style.setProperty("--bs-primary-rgb", hexToRGB(PROVIDER_COLOR));
  root?.style.setProperty("--bs-body-color-rgb", hexToRGB(PROVIDER_COLOR));
  root?.style.setProperty("--bs-primary-hover", hoverColor);
  

  useEffect(() => {
    fetchData();
  }, []);

  const getDamageMarker = () => {
    fetch(`${BASE_URL}${DAMAGE_DATA}`).then((response) => {
      response.json().then(jsonResponse => {
        if(jsonResponse.status === 'success'){
          setDamageData(jsonResponse.data);
        } else {
          setDamageData([]);
        }
      });
    });
  }
  const handleChange = (e, option) => {
    if (option) {
      setFormValues({ ...formValues, [e.target.name]: option });
    } else {
      setFormValues({ ...formValues, [e.target.name]: e.target.value });
    }
  };

  const handleUpdateValue = (keyToStore, value) => {
    setFormValues({ ...formValues, [keyToStore]: value });
  };
  const handleMultipleValues = keyValueArray => {
    const intFormValues = formValues;

    for(let [key, value] of Object.entries(keyValueArray)){
      intFormValues[key] = value;
    }

    setFormValues(intFormValues);
  };

  const removeMultipleValues = keyValueArray => {
    const intFormValues = formValues;

    for(let [key, value] of Object.entries(keyValueArray)){
      console.log(key, value)
      delete intFormValues[key];
    }
    
    setFormValues(intFormValues);
  };

  const handleChangeSelect = (e, claimantSelect) => {
    const selectedIndex = e.target.selectedIndex;
    if (claimantSelect === true) {
      const selectedPolicy = providerData.data.provider.policies.find(x => x.id == e.target.value);
      webFormData.data.policies.forEach(appUserData => {  
        if(appUserData.policyId === selectedPolicy.id){
          setAppUserPolicyData(appUserData);
        }
      });
      setPolicyForm(
        selectedPolicy.reportForm.pages
      );
    } else {
      setFormValues({ ...formValues, [e.target.name]: e.target.value });
    }
  };

  const handleRequiredField = (name) => {
    if(!requiredFields.includes(name)){    
      const tmpArray =  requiredFields.concat([name]);
      setRequiredFields(tmpArray);
    }
  };

  const handleDvlaValue = (keyToStore, value) => {
    setDvlaClassFields({ ...dvlaClassFields, [keyToStore]: value });
  };

  // const pages =
  //   providerData && providerData.data.provider.policies[0].reportForm.pages;
  const logo = providerData && providerData.data.provider.largeLogo;
  const prefix = "https://manager.insureapps.co.uk";
  const appendedLogo = prefix + logo;

  return (
    <DataContext.Provider
      value={{
        providerData,
        handleChange,
        handleUpdateValue,
        handleChangeSelect,
        termsAccepted,
        setTermsAccepted,
        activeTab,
        setActiveTab,
        activeTab,
        policyForm,
        setPolicyForm,
        formValues,
        setNavArray,
        navArray,
        appUserPolicyData,
        endpointError,
        startDescription,
        claimantDescription,
        handleRequiredField,
        requiredFields,
        damageData,
        handleMultipleValues,
        removeMultipleValues,
        handleDvlaValue,
        dvlaClassFields,
        privacyPolicy,
        webFormData
      }}
    >
      <div
        className="App"
        style={{ backgroundImage: `url('//manager.insureapps.co.uk/assets/images/webform/background-${PROVIDER_ID}.png')` }}
      >
        {providerData || endpointError ? (
          <>
            {logo && (<HeaderLogo logo={appendedLogo} />)}
            <NavbarAndForm />
          </>
        ) : (
          <Loading />
        )}

        <Footer />
      </div>
    </DataContext.Provider>
  );
}

export default App;
